import { CuttingState } from "./CuttingState.d";
import { ShipmentState } from "./ShipmentState.d";
import { ShipmentType } from "./ShipmentType.d";
import { UserType } from "./UserType.d";
import { CordwoodMeasurementType } from "./CordwoodMeasurementType.d";


import {ID, ListRequest} from "../../../types/global.d";
import {displayTime, displayDate, displayDateTime} from "../../../utils/formatDate";
import {OrderBy} from "../../../types/global.d";

// Interface for entity Cuttings


export interface Cutting {
    id: ID;

    
    name: string;

    
    state: CuttingState;

    
    startAt: Date;

    
    endAt: Date;

    
    workOrder?: string;

    
    locationId: ID;

    
    providerId: ID;

    
    contractorId: ID;

    
    forestOwnerId?: ID;

    
    scopeGroupId: ID;

    
    contractorScopeGroupId: ID;

    }

export interface FilterAdvancedPresentationRequest {
    list: ListRequest,
    filter: {
        
            name?: string,
        
    
    

            state: CuttingState[],
        
    
    

            forestOwnerId?: ID,
        
    
    forestOwnerIdInclude: boolean,
startAtFrom?: Date,
            startAtTo?: Date,
        
    
    



        providerIdRefs?: ID[],
        contractorIdRefs?: ID[],
        forestOwnerIdRefs?: ID[],
        orderBys: OrderBy[],
        caseSensitive: boolean,
    },
}



export interface CreateCutting {
    
    name: string;

    
    state: CuttingState;

    
    startAt: Date;

    
    endAt: Date;

    
    workOrder?: string;

    
    locationId: ID;

    
    providerId: ID;

    
    contractorId: ID;

    
    forestOwnerId?: ID;

    
    
    }


export interface UpdateCutting {
    
    name: string;

    
    state: CuttingState;

    
    startAt: Date;

    
    endAt: Date;

    
    workOrder?: string;

    
    locationId: ID;

    
    
    
    forestOwnerId?: ID;

    
    
    }

export interface PresentationCuttingRequest {
    list: ListRequest,
    filter: {
        name: string,
        nameOr: boolean,
        providerIdRefs?: ID[],
        contractorIdRefs?: ID[],
        forestOwnerIdRefs?: ID[],
        orderBys: OrderBy[],
        caseSensitive: boolean,
    },
}

export class PrimaryCutting {
    id: string;


    constructor(
        id: ID,
        ) {
        this.id = id?.toString();
        }

    static fromEntity(entity: Cutting): PrimaryCutting | undefined {
        return entity ? new PrimaryCutting(
            entity.id,
        ) : undefined;
    }

    static fromId(id: ID
): PrimaryCutting {
        return new PrimaryCutting(
                id,
                );
    }
    
    static fromPath(path?: string): PrimaryCutting {
        let vals = path?.split('/');
        return new PrimaryCutting(
                   vals[0],
                );
    }

    static fromQuery(value?: string): number | undefined {
        return value ? value : undefined
    }

    toPath(): string {
        let ids = [
            this.id,
            ];
        return ids.join('/');
    }

    static toQueryParams(ids: PrimaryCutting[]): string {
        return '?ids=' + ids.map(id => id.id).join('&ids=');
    }
}

export function toString(entity?: Cutting): string {
    let fields = entity ? [
    entity.name,
            ] : [];
    return fields.filter(item => item).join(' | ');
}

export class UpdateEntityCutting {
    id: PrimaryCutting;
    data: UpdateCutting;


    constructor(id: PrimaryCutting, data: UpdateCutting) {
        this.id = id;
        this.data = data;
    }
}
